import {action, getter, Module, mutation, VuexModule} from "vuex-class-component"
import {FlushMessage, Site} from "@/interface"
import {vxm} from "@/store"

@Module({namespacedPath: "app/"})
export default class AppModule extends VuexModule {

  @getter
  public selected_site_id: number = 999999

  @getter
  public notification_filter: { statuses?: string[] } = {}

  @getter
  public sites: Site[] = []

  @getter
  public flush_messages: any[] = []

  @mutation
  setSiteId(val: number) {
    this.selected_site_id = val
    localStorage.setItem("selected_site_id", val.toString())
  }

  @mutation
  setSites(sites: Site[]) {
    this.sites = sites
  }

  @mutation
  setNotificationFilter(filter: any) {
    this.notification_filter = filter
  }

  @mutation
  addFlushMessage(payload: FlushMessage) {
    const id = Math.ceil((Math.random() * 10)).toString()
    payload.id = id
    this.flush_messages.push(payload)
    if (payload.life_time !== 0) {
      if (payload.life_time === undefined) payload.life_time = 3000
      setTimeout(() => vxm.app.deleteMessage(id), payload.life_time)
    }
  }

  @mutation
  deleteMessage(id: string) {
    const index = this.flush_messages.findIndex(m => m.id === id)
    if (index !== -1) this.flush_messages.splice(index, 1)
  }

  @action()
  async initialize(): Promise<void> {

    // ログインユーザーの取得
    const me = vxm.auth.user
    if (!me) return

    // サイト全件取得
    await vxm.site.fetchSites(true)
    this.setSites(vxm.site.sites.filter(site => {
      if (!me.domains) return false
      if (!site.id) return false
      return me.domains.indexOf(site.id.toString()) !== -1
    }))

    // 選択中のサイトの処理
    const selected_id_str: string | null = localStorage.getItem("selected_site_id")
    const selected_id: number | null = selected_id_str ? parseInt(selected_id_str) : null
    if (selected_id !== null) {
      // @ts-ignore
      this.setSiteId(selected_id)
    } else {
      if (this.sites.length > 0) {
        // @ts-ignore
        this.setSiteId(this.sites[0].id)
      }
    }

    // フィルタサルベージ
    const str_notification_filter = localStorage.getItem("notification_filter")
    this.setNotificationFilter(str_notification_filter ? JSON.parse(str_notification_filter) : {})
  }

  @action()
  async updateNotificationFilter(payload: any) {
    localStorage.setItem("notification_filter", JSON.stringify(payload))
    this.setNotificationFilter(payload)
  }

  @action()
  async finalize(): Promise<void> {
    this.setSites([])
  }
}